module.exports = __webpack_public_path__ + "static/p4-f6f159eb4b5be2d84ec6c80d069d0da9.jpg";